import EditLocationTemplate from './editLocation.html';
import EditLocationDataProviderModule from './editLocationDataProvider.js';
import ComponentsModule from './components/components.js';
import TabsModule from './tabs/tabs.js';

const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';

export default angular
  .module('main.locations.edit', [
    EditLocationDataProviderModule,
    ComponentsModule,
    TabsModule
  ])
  .config(EditLocationRouter)
  .name;

function EditLocationRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.locations.edit', {
      url: `/edit/:locationId?:tab?:from`,
      template: EditLocationTemplate,
      controller: EditLocationController,
      params: {
        location: null,
        locationId: {
          squash: true,
          value: null
        }
      }
    });
}

function EditLocationController($scope,
                                $rootScope,
                                $q,
                                $filter,
                                $state,
                                EditLocationDataProvider,
                                utils,
                                ToastsService,
                                PermissionsService) {

  const $t = $filter('translate');
  const deleteModalOptions = [
    {
      id: 1,
      name: $t('locations.edit.deleteModal.deleteOptions.1.name'),
      desc: $t('locations.edit.deleteModal.deleteOptions.1.desc')
    },
    {
      id: 2,
      name: $t('locations.edit.deleteModal.deleteOptions.2.name'),
      desc: $t('locations.edit.deleteModal.deleteOptions.2.desc')
    }
  ];

  if ($state.params.locationId && $state.params.locationId != utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY)?.id) {
    utils.removeStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
  }

  // NOTE: Dirty hack for fast injecting ready-to-use data provider to child components
  EditLocationDataProvider.instance = new EditLocationDataProvider();
  let dataProvider = EditLocationDataProvider.instance;
  $scope.dataProvider = dataProvider;

  // #region Navigation Tabs
  $scope.tabs = [
    {
      id: 'dashboard',
      name: $t('locations.edit.dashboard'),
      icon: 'far fa-chart-bar'
    },
    {
      id: 'relatives',
      name: $t('locations.edit.relatives'),
      icon: 'far fa-link'
    },
    {
      id: 'info',
      name: $t('locations.new.info.title'),
      icon: 'far fa-file-alt',
      hidden: true,
      silent: true
    },
    {
      id: 'subscriptions',
      name: $t('form.service-plans'),
      icon: 'far fa-scroll'
    },
    {
      id: 'users',
      name: $t('menu.users'),
      icon: 'iotr fa-friends'
    },
    {
      id: 'devices',
      name: $t('menu.devices'),
      icon: 'iotr fa-gateway'
    },
    {
      id: 'events',
      name: $t('form.events'),
      icon: 'far fa-history'
    },
    {
      id: 'services',
      name: $t('questions.title'),
      icon: 'far fa-sliders-h'
    },
    {
      id: 'scenes',
      name: $t('locations.edit.scenes'),
      icon: 'far fa-home',
      hidden: true
    },
    {
      id: 'bots',
      name: $t('bots.bots'),
      icon: 'iotr fa-bot'
    },
    {
      id: 'rules',
      name: $t('form.rules'),
      icon: 'iotr fa-rules'
    },
    {
      id: 'settings',
      name: $t('locations.edit.properties'),
      icon: 'far fa-drafting-compass'
    },
    {
      id: 'states',
      name: $t('locations.edit.states'),
      icon: 'far fa-drafting-compass',
      hidden: true
    },
    {
      id: 'editTask',
      name: $t('locations.edit.tasks.header'),
      icon: 'far fa-tasks',
      hidden: true
    },
    {
      id: 'priorities',
      name: $t('locations.edit.priorityHistory'),
      icon: 'far fa-map-marker',
      hidden: true
    },
    {
      id: 'trendsHistory',
      name: $t('locations.edit.trendsHistoryTab'),
      icon: 'far fa-analytics',
      hidden: true
    }
  ];

  // #endregion

  angular.extend($scope, {
    onAddNewTaskButtonClick: onAddNewTaskButtonClick,
    onEditLocationButtonClick: onEditLocationButtonClick,
    onDeleteLocationButtonClick: onDeleteLocationButtonClick,
    canDeleteLocation: canDeleteLocation,
    copyToClipboard: $rootScope.copyToClipboard,
    deleteLocationName: undefined,
  });

  init();

  function init() {
    $scope.loading = true;

    $q.all([
      checkPermissions(),
      dataProvider.mainResourceGroup.init(),
    ])
      .then(() => {
        $scope.isDeviceOnlyLocation = dataProvider.locationResource.value?.subType === 1;

        // Check location sub-type and hide specified tabs
        if ($scope.isDeviceOnlyLocation) {
          let hiddenTabs = ['subscriptions', 'users', 'services', 'bots'];
          hiddenTabs.forEach((tab) => {
            let targetTab = $scope.tabs.find(t => t.id === tab);
            targetTab.hidden = true;
          });
        }

        // Set default tab, only if main resources loaded successfully
        dataProvider.activeTab = $state.params.tab || 'dashboard';
      }, (err) => {
        if (err?.resultCode === 7) { // Access denied
          // TODO describe error
          $scope.accessDeniedError = true;
          $scope.isError = true;
          $scope.errorTitle = $t('locations.edit.errors.accessDenied.title');
          $scope.errorDesc = $t('locations.edit.errors.accessDenied.desc');
          return $q.reject();
        } else if (err?.resultCode === 8) { // Object not found
          // TODO describe error
          $scope.notFoundError = true;
          $scope.isError = true;
          $scope.errorTitle = $t('locations.edit.errors.notFound.title');
          $scope.errorDesc = $t('locations.edit.errors.notFound.desc');
          return $q.reject();
        }
        return $q.reject(err);
      })
      .then(() => {
        return dataProvider.isLocationTasksEditableResource.init();
      })
      .then(() => {
        $scope.loading = false;
      }, (err) => {
        $scope.loading = false;
        if (err) {
          utils.handleApiError(err);
        }
        // dataProvider.goBack();
      });

    $scope.$watch('dataProvider.locationResource.value', () => {
      $scope.isDeviceOnlyLocation = dataProvider.locationResource.value?.subType === 1;
      $scope.locationAddress = getLocationAddress();
    }, true);

    $scope.$on('$destroy', () => {
      dataProvider.destroy();
      EditLocationDataProvider.instance = undefined;
      $('#delete-location-modal').remove();
    });

    // Custom form validation rule
    $.fn.form.settings.rules.notLocationName = function(value) {
      if ($scope.deleteLocationName === dataProvider.locationResource.value.name) {
        return true;
      }
      return false;
    };

    // Initialize form validation rules
    $('#delete-location-form').form({
      inline: true,
      fields: {
        'location-name': {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.locations.name.empty')
            },
            {
              type: 'notLocationName',
              prompt: $t('locations.edit.deleteModal.notMatch')
            }
          ]
        },
      }
    });
  }

  /**
   * Check if we have enough permissions to see this location
   * @return {Promise}
   */
  function checkPermissions() {
    return dataProvider.canIEditLocationResource.init()
      .then((allowed) => {
        if (allowed === false) {
          ToastsService.error($t('locations.edit.wrongPermissions.title'), $t('locations.edit.wrongPermissions.desc'));
          dataProvider.goBack();
        }
      });
  }

  /**
   * Get well-formatted location address
   * @return {string|undefined}
   */
  function getLocationAddress() {
    if (!dataProvider.locationResource.value) {
      return;
    }
    let address = utils.generateAddress(dataProvider.locationResource.value);
    if (!address) {
      return $t('common.unknown-address');
    }
    return address;
  }

  function onAddNewTaskButtonClick() {
    if ($scope.dataProvider.activeTab === 'editTask') {
      return;
    }
    $scope.dataProvider.taskToEdit = undefined;
    $scope.dataProvider.activeTab = 'editTask';
  }

  function onEditLocationButtonClick() {
    if ($scope.dataProvider.activeTab === 'info') {
      $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
      return;
    }
    $scope.dataProvider.activeTab = 'info';
  }

  function canDeleteLocation() {
    if (!dataProvider.locationResource.value) {
      return false;
    }
    return PermissionsService.canIDeleteLocation(dataProvider.locationResource.value);
  }

  function canIDeleteUser(user) {
    if (!dataProvider.locationResource.value) {
      return;
    }
    return PermissionsService.canIDeleteAndMergeUser(user);
  }

  function onDeleteLocationButtonClick() {
    // Check to show delete user option
    if (canIDeleteUser()) {
      dataProvider.locationAdminUsersResource.init()
        .then((data) => {
          let user = data && data.length === 1 ? data[0] : void 0;
          if (user && canIDeleteUser(user)) {
            $scope.userToDelete = user;
            $scope.deleteOptions = deleteModalOptions;
            $scope.selectedDeleteOptionId = 1;
          }
        });
    }

    $('#delete-location-modal')
      .modal({
        autofocus: false,
        closable: false,
        detachable: true,
        onApprove: () => {
          $('#delete-location-form').form('validate form');
          if (!$('#delete-location-form').form('is valid')) {
            return false;
          }

          $scope.$applyAsync(() => {
            $scope.loading = true;
            if ($scope.userToDelete && $scope.selectedDeleteOptionId === 2) {
              return deleteUserAndLocation();
            }
            deleteLocation();
          });
        },
        onHidden: () => {
          $scope.$applyAsync(() => {
            $scope.deleteLocationName = undefined;
            $('#delete-location-form').form('reset');
          });
        }
      })
      .modal('show');
  }

  function deleteUserAndLocation() {
    return dataProvider.deleteUser($scope.userToDelete.id)
      .then(() => {
        $scope.loading = false;
        ToastsService.success(null, $t('locations.edit.deleteModal.deleteUserAndLocation', {
          user: $scope.userToDelete.userName,
          location: dataProvider.locationResource.value.name || $t('common.unknownLocation'),
          id: dataProvider.locationResource.value.id
        }));
        dataProvider.goBack();
      }, (err) => {
        $scope.loading = false;
        utils.handleApiError(err);
      });
  }

  function deleteLocation() {
    return dataProvider.deleteLocation()
      .then(() => {
        $scope.loading = false;
        ToastsService.success(null, $t('common.deleteLocationSuccess', {
          id: dataProvider.locationResource.value.id
        }));
        dataProvider.goBack();
      }, (err) => {
        $scope.loading = false;
        utils.handleApiError(err);
      });
  }

}
